/** Version of the investment round contract */
export enum PropertyInvestmentRoundContractVersion {
  Initial = 1,
  WithConfirmedContract = 2,
}
